<div class="master-modal account_request_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{idValue ? 'Edit': 'Add'}} Address</h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form [formGroup]="addressForm" (ngSubmit)="addUpdateAddress()" class="form-section address-form-section">
        <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
              <!-- Phone No -->
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- Select Address Type -->
                  <div class="custom-form-group">
                    <label class="custom-label mb-10" for=""> Address Type <span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-button-toggle-group appearance="legacy" formControlName="type" class="address_toggle">
                        <mat-button-toggle value="Home">Home</mat-button-toggle>
                        <mat-button-toggle value="Work">Work</mat-button-toggle>
                        <mat-button-toggle value="Other">Other</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill *ngIf="type.value === 'Other'">
                  <!-- Select Address Type -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Other type <span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="text" matInput formControlName="other_type_name"
                          placeholder="Enter other type name" />
                        <mat-error
                          *ngIf="other_type_name.invalid && (other_type_name.dirty || other_type_name.touched)">
                          <span *ngIf="other_type_name.hasError('required')"> Please enter other type </span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
                fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div fxLayout="column" fxFlex="100" fxFlexFill>
                  <div class="form-section">
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <input type="text" matInput placeholder="Search Location" autocorrect="off"
                            autocapitalize="off" spellcheck="off" type="text" #search />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="address-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div class="address-column" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100"
                  fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
                  <!-- First Name-SELECT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Name<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="text" matInput formControlName="short_name" placeholder="Enter name" />
                        <mat-error *ngIf="short_name.invalid && ( short_name.dirty || short_name.touched )">
                          <span> Name is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Line 1 -->
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- Address-INPUT -->
                  <div class="custom-form-group text-area-group">
                    <label class="custom-label" for="">Address Line1<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <textarea rows="2" cols="2" matInput formControlName="line_1"
                          placeholder="Enter address line 1">
                        </textarea>
                        <mat-error *ngIf="line_1.invalid && ( line_1.dirty || line_1.touched )">
                          <span>Line 1 is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- Address-INPUT -->
                  <div class="custom-form-group text-area-group">
                    <label class="custom-label" for="">Address Line2</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <textarea rows="2" cols="2" matInput formControlName="line_2"
                          placeholder="Enter address line 2">
                        </textarea>
                        <mat-error *ngIf="line_2.invalid && ( line_2.dirty || line_2.touched )">
                          <span>Line 2 is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Phone No -->
              <div class="address-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div class="address-column mobile_mb_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <!-- PHone No-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Landmark</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="text" matInput placeholder="Enter landmark" formControlName="landmark">
                        <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )">
                          <span>Landmark is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="address-column mobile_mb_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <!-- PHone No-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">City<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="text" matInput placeholder="Enter city" formControlName="city">
                        <mat-error *ngIf="city.invalid && ( city.dirty || city.touched )">
                          <span>City is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="address-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div class="address-column mobile_mb_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <!-- State-SELECT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">State<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select State" formControlName="state">
                          <mat-option disabled=""> Select State </mat-option>
                          <mat-option value="Australian Capital Territory">Australian Capital Territory</mat-option>
                          <mat-option value="New South Wales">New south wales</mat-option>
                          <mat-option value="Northern Territory">Northern Territory</mat-option>
                          <mat-option value="Queensland">Queensland</mat-option>
                          <mat-option value="South Australia">South australia</mat-option>
                          <mat-option value="Western Australia">Western australia</mat-option>
                          <mat-option value="Victoria">Victoria</mat-option>
                        </mat-select>
                        <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )">
                          <span>State is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="address-column mobile_mb_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <!-- Country-SELECT -->
                  <div class="custom-form-group">
                    <!-- <label class="custom-label" for="">Country<span class="star">*</span></label> -->
                    <div class="custom-form-control">
                      <label class="custom-label" for="">Country<span class="star"
                          style="display: inline-block !important;">*</span></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Country" formControlName="country">
                          <mat-option disabled=""> Select country </mat-option>
                          <mat-option value="Australia">Australia</mat-option>
                        </mat-select>
                        <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )">
                          <span>Country is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="address-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
                <div class="address-column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <!-- Pincode-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Postal code<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Post Code / ZIP" formControlName="postal_code">
                        <mat-error *ngIf="postal_code.invalid && ( postal_code.dirty || postal_code.touched )">
                          <span>Postal code is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
              <span>Cancel</span>
            </button>
            <button mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
